import React from "react"
import Form from "react-bootstrap/Form"
import { Form as FinalForm } from "react-final-form"
import arrayMutators from "final-form-arrays"
import FormNavigation from "../../common/FormNavigation"
import { StyledExplanation } from "../../common/styles/FormStyles"
import PriceCalculationProducerForm from "./includes/priceCalculationProducer/PriceCalculationProducerForm"
import PriceCalculationConsumerForm from "./includes/priceCalculationConsumer/PriceCalculationConsumerForm"
import { connect } from "react-redux"
import { compose } from "redux"

export class ProductPriceCalculationForm extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      clicked: false,
    }
  }

  setSaveClicked(isClicked) {
    this.setState({ clicked: isClicked })
  }

  render() {
    return (
      // handleSubmit needed for local validation of fields
      <Form onSubmit={this.props.handleSubmit}>
        <StyledExplanation>
          {this.props.isProducer ? (
            <>
              Hier können Sie die Dienstleistungsentgelte pro Erzeugungsart
              festlegen. Im Falle einer Festpreisvergütung können Sie zusätzlich
              die Höhe des Festpreises angeben.
            </>
          ) : (
            <>
              Hier können Sie festlegen, wie Arbeitspreis und Grundpreis
              berechnet werden sollen. Außerdem können optional abweichende
              Displaynamen festgelegt werden.
            </>
          )}
        </StyledExplanation>

        {this.props.isProducer ? (
          <PriceCalculationProducerForm disabled={this.props.disabled} />
        ) : (
          <PriceCalculationConsumerForm
            saveClicked={this.state.clicked}
            {...this.props}
          />
        )}

        <br />
        <br />
        <br />
        <br />
        <br />

        <FormNavigation
          onSaveHandler={this.props.onSaveProductOffer}
          onPreviousPageHandler={this.props.onPreviousPage}
          nextTabKey={this.props.nextTabKey}
          previousTabKey={this.props.previousTabKey}
          setSaveClicked={this.setSaveClicked.bind(this)}
        />
      </Form>
    )
  }
}

function mapStateToProps(state) {
  return {
    initialValues: state.productOffers.definition.formData,
  }
}

export default compose(connect(mapStateToProps))((props) => (
  <FinalForm
    onSubmit={() => null}
    initialValues={props.initialValues}
    mutators={{ ...arrayMutators }}
    render={({ handleSubmit, form, values }) => {
      if (props.registerFinalForm) {
        props.registerFinalForm(form)
      }

      return (
        <ProductPriceCalculationForm
          {...props}
          handleSubmit={handleSubmit}
          form={form}
          values={values}
        />
      )
    }}
  />
))
